import * as React from "react"

const SvgComponent = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  const w = 50
  const h = 50
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="50" height="50" rx="25" fill="white" />
      <path d="M30.0625 18.8125H27.5312C27.2206 18.8125 26.9688 19.0643 26.9688 19.375V30.625C26.9688 30.9357 27.2206 31.1875 27.5312 31.1875H30.0625C30.3732 31.1875 30.625 30.9357 30.625 30.625V19.375C30.625 19.0643 30.3732 18.8125 30.0625 18.8125Z" fill="#616161" stroke="#616161" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.4688 18.8125H19.9375C19.6268 18.8125 19.375 19.0643 19.375 19.375V30.625C19.375 30.9357 19.6268 31.1875 19.9375 31.1875H22.4688C22.7794 31.1875 23.0312 30.9357 23.0312 30.625V19.375C23.0312 19.0643 22.7794 18.8125 22.4688 18.8125Z" fill="#616161" stroke="#616161" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default SvgComponent
